<ng-container [formGroup]="parentFormGroup">
  <div class="mt-3 ms-2 mb-3 d-flex align-items-center">
    <mat-checkbox
      class="w-100"
      [ngClass]="{ 'ui-disabled': readOnly }"
      [formControlName]="currentConfig.property"
      (change)="onValueChanged()"
    >
      {{ currentConfig.displayText }}
    </mat-checkbox>
    <ra-tooltip class="ms-2" [tooltipConfig]="currentConfig?.tooltipConfig">
    </ra-tooltip>
  </div>
  @if (parentFormGroup?.get(currentConfig.property)?.errors) {
    <mat-error>
      {{
        currentConfig?.errorMessages?.[
          keys(parentFormGroup?.get(currentConfig.property)?.errors)?.[0]
        ] || "Please review the field"
      }}
    </mat-error>
  }
</ng-container>
